export default __webpack_public_path__ + "static/media/Logo-1.73f5e4d8.svg";